import React from 'react'

import OnboardingModal from '@/modules/base/components/modal/onboarding-modal/onboarding-modal'
import { updateSubscriptionDetails } from '@/redux/ducks/subscription/details'
import { UNSAFE_renderElement as renderElement } from '@/hooks/useGlobalPortal'
import { isMeinBuero } from '@/utils/build-env'
import { navigate } from '@/modules/layout/util/useInterceptedNavigate'
import store from '@/redux/store'
import { isOnboardingNavigationEnabled } from '@/modules/_helpers/firstSteps'

// The function is called multiple times if you click on the button in the verification code email
// This prevents it from opening the modal multiple times
// FYI: DO-7436: 5.Fehler
let isOpen = false
const openOnboardingModal = () => {
  if (isOpen || !renderElement) return
  isOpen = true
  try {
    renderElement((close) => (
      <OnboardingModal
        open
        onClose={() => {
          isOpen = false
          updateSubscriptionDetails(true).then((subscriptionData) => {
            close()
            const isDemo = store.getState().user.info?.isDemo || false
            const isOnShop = typeof window !== 'undefined'
              && window.location?.pathname?.startsWith('/shop')
            if (
              isMeinBuero()
              && isOnboardingNavigationEnabled(subscriptionData?.subscriptions ?? [], isDemo)
              && !isOnShop
            ) {
              navigate('/firstSteps')
            }
          })
        }}
      />
    ))
  } catch (e) {
    isOpen = false
    throw e
  }
}

export const isOnboardingOpen = () => isOpen
export const setOnboardingOpen = (value) => { isOpen = value }

export default openOnboardingModal
